import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import IInfo from '../types/common/IInfo';
import InfoService from '../services/common/InfoService';
import DemographicActions from '../common/actions/DemographicActions';
import { LOGOUT, SELECT_CUSTOMER } from '../constants/actions/auth.constants';
import defaultLocales from '../config/defaultLocales.json';

const NAME = 'Info';

const getInfo = createAsyncThunk(`${NAME}/getInfo`, InfoService.getInfo);

type State = {
    data: IInfo | undefined;
    loading: boolean;
    error: boolean;
    requestId: string | null;
};

const initialState: State = {
    data: undefined,
    loading: false,
    error: false,
    requestId: null,
};

const slice = createSlice({
    name: NAME,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getInfo.pending, (state, action) => {
            state.loading = true;
            state.error = false;
            state.requestId = action.meta.requestId;
        });
        builder.addCase(getInfo.fulfilled, (state, action) => {
            if (
                state.loading === true &&
                state.requestId === action.meta.requestId
            ) {
                state.loading = false;
                state.data = action.payload?.data;
                state.requestId = null;
            }
        });
        builder.addCase(getInfo.rejected, (state, action) => {
            if (
                state.loading === true &&
                state.requestId === action.meta.requestId
            ) {
                state.loading = false;
                state.error = true;
                state.requestId = null;
                state.data = {
                    languages: defaultLocales as string[],
                    showDemographicCriteria: false,
                    translationVersion: 'v0.0.1',
                    logo: '',
                    customization: null,
                    companyId: null,
                    companyName: null,
                };
            }
        });

        builder.addCase(DemographicActions.postAnswer.fulfilled, (state) => {
            if (state.data) {
                state.data.showDemographicCriteria = false;
            }
        });

        builder.addCase(LOGOUT, (state) => {
            state.data = undefined;
        });

        builder.addCase(SELECT_CUSTOMER, (state) => {
            state.data = undefined;
            state.loading = false;
            state.requestId = null;
        });
    },
});

const InfoActions = {
    getInfo,
};

export default InfoActions;
export const InfoReducer = slice.reducer;
